import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/compat/firestore';
import { from, Observable } from 'rxjs';
import { WidgetInterface } from '../interfaces/widget.interface';
import { AuthService } from './auth.service';
import firebase from 'firebase/compat/app';

const WIDGETS_COLLECTION = 'widgets-collection';

@Injectable()
export class WidgetService {
    public widgetsCollection: AngularFirestoreCollection<WidgetInterface>;

    public constructor(
        private readonly firestore: AngularFirestore,
        private readonly authService: AuthService,
    ) {
        this.widgetsCollection = this.firestore.collection<WidgetInterface>(WIDGETS_COLLECTION);
    }

    public get(widgetId: string): Observable<WidgetInterface> {
        return this.widgetsCollection.doc<WidgetInterface>(widgetId).valueChanges();
    }

    public update(widgetId: string, dataToUpdate: Partial<WidgetInterface>): Observable<void> {
        dataToUpdate.updatedAt = firebase.firestore.Timestamp.now();
        dataToUpdate.updatedBy = this.authService.getEmail();
        return from(this.widgetsCollection.doc<WidgetInterface>(widgetId).update(Object.assign({}, dataToUpdate)));
    }
}
